import React from 'react';
// import { motion } from 'framer-motion';
// import { FaQuoteLeft, FaStar, FaCommentDots } from 'react-icons/fa';
import './Testimonials.scss';

const companies = [
  'Quantum Tech School', 'Infinity Project'
];

// const testimonials = [
//   {
//     id: 1,
//     name: 'Алексей Иванов',
//     role: 'Операционный директор, TechFlow',
//     content: 'Внедрение платформы позволило нам сократить время реакции на внутренние заявки в 3 раза. Идеальный инструмент для оцифровки бизнес-процессов.',
//     avatar: 'АИ',
//     color: '#3b82f6'
//   },
//   {
//     id: 2,
//     name: 'Мария Смирнова',
//     role: 'HR Director, GlobalSoft',
//     content: 'Наконец-то мы полностью отказались от хаоса в мессенджерах. Теперь каждый сотрудник видит статусы своих запросов, а руководство трекает реальную загрузку отделов.',
//     avatar: 'МС',
//     color: '#5cd5f6'
//   },
//   {
//     id: 3,
//     name: 'Тимур Касенов',
//     role: 'CEO, KazCompany',
//     content: 'Искали простое, но гибкое решение для внутреннего сервис-деска. Система превзошла все ожидания — настроили ролевую модель и обходные листы за пару дней.',
//     avatar: 'ТК',
//     color: '#10b981'
//   }
// ];

const Testimonials: React.FC = () => {
  return (
    <section id='testimonials' className="testimonials section">
      {/* Logos Marquee */}
      <div className="trusted-by">
        <p className="trusted-by__title">ЭТИ КОМПАНИИ УЖЕ ВЫБРАЛИ НАШУ СИСТЕМУ</p>
        <div className="marquee">
          <div className="marquee__content">
            {companies.map((company, index) => (
              <span key={`company-1-${index}`} className="company-logo">{company}</span>
            ))}
            {/* Duplicate for infinite effect */}
            {/* {companies.map((company, index) => (
              <span key={`company-2-${index}`} className="company-logo">{company}</span>
            ))} */}
          </div>
        </div>
      </div>

    </section>
  );
};
      // <div className="container">
      //   <motion.div 
      //     className="section-heading"
      //     initial={{ opacity: 0, y: 30 }}
      //     whileInView={{ opacity: 1, y: 0 }}
      //     viewport={{ once: true }}
      //   >
      //     <span className="section-badge">Отзывы клиентов</span>
      //     <div className="section-heading__title-wrapper">
      //       <div className="section-heading__icon">
      //         {/* @ts-ignore */}
      //         <FaCommentDots />
      //       </div>
      //       <h2 className="section-heading__title">Что о нас говорят</h2>
      //     </div>
      //     <p className="section-heading__subtitle">
      //       Мы гордимся тем, что помогаем бизнесу становиться эффективнее. Читайте отзывы наших клиентов.
      //     </p>
      //   </motion.div>

      //   <div className="testimonials__grid">
      //     {testimonials.map((testimonial, idx) => (
      //       <motion.div 
      //         key={testimonial.id}
      //         className="review-card"
      //         initial={{ opacity: 0, y: 30 }}
      //         whileInView={{ opacity: 1, y: 0 }}
      //         viewport={{ once: true }}
      //         transition={{ delay: idx * 0.15, duration: 0.6 }}
      //       >
      //         {/* @ts-ignore */}
      //         <FaQuoteLeft className="quote-icon" />
              
      //         <div className="review-card__stars">
      //           {[...Array(5)].map((_, i) => (
      //             // @ts-ignore
      //             <FaStar key={i} className="star-icon" />
      //           ))}
      //         </div>

      //         <p className="review-card__content">
      //           "{testimonial.content}"
      //         </p>

      //         <div className="review-card__author">
      //           <div 
      //             className="author-avatar"
      //             style={{ backgroundColor: `${testimonial.color}15`, color: testimonial.color }}
      //           >
      //             {testimonial.avatar}
      //           </div>
      //           <div className="author-info">
      //             <h4 className="author-name">{testimonial.name}</h4>
      //             <p className="author-role">{testimonial.role}</p>
      //           </div>
      //         </div>
      //       </motion.div>
      //     ))}
      //   </div>
      // </div>

export default Testimonials;
